import React, { useEffect, useState } from 'react';
import Layout from '~/components/Layout';
import { useTranslation } from 'react-i18next';
import { RouteTypes } from '~/routes/constants';
import { Dropdown, Input, Tab } from 'semantic-ui-react';
import { El } from '~/components/Layout/style';
import { useNavigate } from 'react-router-dom';
import TableComponent from '~/components/TableComponent';
import { MilkMoneyQuery } from '~/QueryHooks/MilkMoneyQuery';
import { useAuth } from '~/routes/components/AuthProvider';
import { LIGHT_USER_ROLE_SLUG } from '~/Constants';
import { FiltersWrapper } from '../../DairyFactory/ActivityLogs/style';
import styled from 'styled-components';
import FilterDropdown, { getDropdownFilterKeys } from './FilterDropdown';
import Filters from './Filters'
import Export from './Export';
import { useDebounce } from 'use-lodash-debounce';

const ActionWrapper = styled.div`
min-width: 300px !important;
max-height: 40px !important;
display: flex;
 button {
   display: inherit !important;  
 }
`

const MilkDelivery: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const actions = [
    {
      popupMessage: t('Overview Tour Details'),
      type: 'link',
      name: 'eye',
      size: 'large',
      link: RouteTypes.MILK_MONEY_TOURS_SHOW
    }
  ]
  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 30,
    search: '',
    status: '',
    column: '',
    sort: '',
    dateFrom: '',
    dateTo: '',
    totalAmountFrom: '',
    totalAmountTo: '',
    driverNumber: '',
    vehicleNumber: '',
    tourNumber: '',
    month: ''
  })
  const { systemData: { logged: { roleSlug } } } = useAuth()
  const navigate = useNavigate();
  const [search, setSearch] = useState('')
  const [openExport, setOpenExport] = useState(false)
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [checkedFilters, setCheckedFilters] = useState([])
  const debounceSearchValue = useDebounce(search, 300)
  const lightUserLogged = roleSlug === LIGHT_USER_ROLE_SLUG
  const defaultTableColumnHeaders = [
    {
      name: t('Date import'),
      key: 'createdAt',
      type: 'date',
      format: 'DD.MM.YYYY HH:mm',
      sorted: 'desc'
    },
    {
      name: t('Tour start'),
      key: 'dateStart',
      type: 'date',
      format: 'DD.MM.YYYY HH:MM',
      sorted: 'desc'
    },
    {
      name: t('Tour end'),
      key: 'dateEnd',
      type: 'date',
      format: 'DD.MM.YYYY HH:MM',
      sorted: 'desc'
    },
    {
      name: t('Collection truck no.'),
      key: 'vehicleNumber',
      sorted: 'desc'
    },
    {
      name: t('Tour no.'),
      key: 'tourNumber',
      sorted: 'desc'
    },
    {
      name: t('Driver no.'),
      key: 'driverNumber',
      sorted: 'desc'
    },
    {
      name: t('Total amount (in l)'),
      key: 'totalAmount',
      type: 'no-unit-number',
      decimalScale: 0,
      sorted: 'desc'
    },
    {
      name: t('Number of operations'),
      key: 'dataCount',
      sorted: 'desc'
    },
    {
      name: t('Number of samples'),
      key: 'samplesTotal',
      sorted: 'desc'
    },
    {
      name: t('Actions')
    }
  ]
  const [tableColumnHeaders, setTableColumnHeaders] = useState(defaultTableColumnHeaders)

  const {
    data: milkDeliveryOptions,
    isLoading: isBusyOptions,
    refetch: fetchOptions,
    isFetched: optionsFetched
  } = MilkMoneyQuery.getMilkMoneyToursOptions()

  const {
    isLoading: isBusyData,
    data: milkDeliveryData,
    refetch: fetchFilteredData,
    isFetching: isFetchingData
  } = MilkMoneyQuery.getMilkMoneyToursList({
    ...dataFiltered,
    dateFrom: dataFiltered.dateFrom !== '' ? parseDate(dataFiltered.dateFrom) : '',
    dateTo: dataFiltered.dateTo !== '' ? parseDate(dataFiltered.dateTo) : '',
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  }, Boolean(dataFiltered.month !== ''));

  const {
    data: milkDeliveryCount,
    isLoading: isBusyCount,
    refetch: fetchCount
  } = MilkMoneyQuery.getMilkMoneyToursCount({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  }, Boolean(dataFiltered.month !== ''));

  useEffect(() => {
    setTableColumnHeaders(defaultTableColumnHeaders)
    fetchOptions()
    const tempCheck = [...checkedFilters]
    getDropdownFilterKeys().map(filter => {
      const index = tempCheck.findIndex(tempFilter => tempFilter.key === filter.key)
      if (index >= 0) {
        tempCheck[index].placeholder = filter.placeholder
      }
    })
    setCheckedFilters(tempCheck)
  }, [t])

  useEffect(() => {
    if (dataFiltered.month !== '') {
      fetchFilteredData();
      if (milkDeliveryOptions?.inCheckStatusAvailable) {
        fetchCount()
      }
    } else if (milkDeliveryOptions && dataFiltered.month === '') {
      setDataFiltered((prevData) => ({
        ...prevData,
        month: milkDeliveryOptions?.months[0]?.key
      }))
    }
  }, [dataFiltered, optionsFetched]);

  useEffect(() => {
    setDataFiltered({
      ...dataFiltered,
      search: debounceSearchValue
    })
  }, [debounceSearchValue])

  function parseDate(value) {
    const arrayOfValues = value.split('.')
    return `${arrayOfValues[2]}-${arrayOfValues[1]}-${arrayOfValues[0]}`
  }

  function renderFilters() {
    return <FiltersWrapper>
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('Farmer / Supplier number')}
        value={search}
        onChange={(e, data) => setSearch(data.value)}
      />
      <Dropdown
        selectOnBlur={false}
        placeholder={t('Delivery month tour')}
        selection
        value={dataFiltered.month}
        onChange={(e, data) => setDataFiltered({ ...dataFiltered, month: data.value as string })}
        options={milkDeliveryOptions?.months?.map(option => ({ text: option.label, value: option.key })) || []}
      />
      <Filters
        onChangeDataFiltered={(dataFiltered) => setDataFiltered(dataFiltered)}
        milkDeliveryOptions={milkDeliveryOptions}
        checkedFilters={checkedFilters}
        dataFiltered={dataFiltered}
      />
    </FiltersWrapper>
  }

  function renderActions() {
    return <ActionWrapper>
      <FilterDropdown
        checkedFilters={checkedFilters}
        handleCheckFilter={(checked, filter, indexFilter) => {
          if (checked) {
            const newArray = [...checkedFilters];
            newArray.splice(indexFilter, 0, filter);
            setCheckedFilters(newArray)
          } else {
            setCheckedFilters(checkedFilters.filter(filterChecked => filterChecked.key !== filter.key))
          }

        }}
      />
      <El.PageHeaderActionButton
        size='large'
        onClick={() => navigate(RouteTypes.MILK_MONEY_TOURS_IMPORT)}
      >
        {t('Import manually')}
      </El.PageHeaderActionButton>
      <El.PageHeaderActionButton
        size='large'
        onClick={() => setOpenExport(true)}
      >{t('Export')}</El.PageHeaderActionButton>
    </ActionWrapper>
  }

  function renderTable() {
    return <TableComponent
      actions={actions}
      isFetchingData={isFetchingData}
      animated
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data, tableColumnHeaders) => {
        setTableColumnHeaders(tableColumnHeaders)
        setDataFiltered(data)
      }}
      rows={rows}
      total={filtered}
    />
  }

  function handleTabChange(activeIndex) {
    if (!isFetchingData) {
      const status = milkDeliveryOptions?.statuses.find((_, indexOption) => indexOption === activeIndex);
      setDataFiltered({
        ...dataFiltered,
        status: status.key,
        page: 0
      });
      setActiveTabIndex(activeIndex)
    }
  }

  function renderPanes() {
    const panes = milkDeliveryOptions?.statuses.map((option) => {
      const countIndex = milkDeliveryCount?.findIndex((count) => count.status == option.key);
      return {
        menuItem: `${option.label}  (${milkDeliveryCount[countIndex]?.count || 0})`,
        render: () => renderTable()
      };
    });
    return (
      <Tab
        menu={{ secondary: true, pointing: true }}
        activeIndex={activeTabIndex}
        panes={panes}
        onTabChange={(_, data) => handleTabChange(data.activeIndex)}
      />
    );
  }

  function renderContent() {
    if (milkDeliveryOptions?.inCheckStatusAvailable && milkDeliveryCount) {
      return renderPanes()
    }

    return renderTable()
  }

  function renderExportDialog() {
    return <Export
      openExport={openExport}
      handleClose={() => setOpenExport(false)}
    />
  }

  const { filtered, rows } = milkDeliveryData ? milkDeliveryData : { filtered: 0, rows: [] };
  const loading = isBusyOptions || isBusyData || isBusyCount

  return <Layout
    segmented
    isBusy={loading}
    title={t('Overview MSW Tours')}
    filters={renderFilters()}
    actions={!lightUserLogged && renderActions()}
  >
    {milkDeliveryData && milkDeliveryOptions && renderContent()}
    {renderExportDialog()}
  </Layout>;
};

export default MilkDelivery;
